import React from "react";
import { observer } from "mobx-react";
import { UserContentExpirationTemplate } from "themes/administration/user/pages";
import { UserContentExpirationViewStore } from "administration/user/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) =>
        new UserContentExpirationViewStore(rootStore, componentProps),
    "userContentExpirationViewStore"
)
@observer
class UserContentExpiration extends React.Component {
    render() {
        return <UserContentExpirationTemplate {...this.props} />;
    }
}

export default UserContentExpiration;
